import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Calendar, ChevronRight, Grid3x3 } from 'lucide-react';

export default function ShowcaseCTA({ rig }) {
  const bookingUrl = rig.booking_url || '/bookings';
  return (
    <section className="relative py-28 px-6 lg:px-10 border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 carbon-bg opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0d0d0f] via-transparent to-[#0d0d0f]" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="relative max-w-3xl mx-auto text-center"
      >
        <p className="text-primary text-xs font-bold tracking-widest mb-4">YOUR SESSION AWAITS</p>
        <h2 className="text-white font-black text-4xl md:text-6xl uppercase leading-[0.95] mb-6">
          Ready To Race?
        </h2>
        <p className="text-white/50 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
          Book your simulator session today and experience professional-grade sim racing technology.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to={bookingUrl}>
            <button className="group inline-flex items-center gap-2.5 bg-primary hover:bg-primary/90 text-white font-black text-xs tracking-widest px-8 py-4 transition-colors w-full sm:w-auto justify-center">
              <Calendar className="w-4 h-4" /> BOOK THIS RIG
              <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </Link>
          <Link to="/simulators">
            <button className="inline-flex items-center gap-2.5 bg-primary/10 border border-primary/40 text-white hover:bg-primary hover:border-primary font-black text-xs tracking-widest px-8 py-4 transition-colors w-full sm:w-auto justify-center">
              <Grid3x3 className="w-4 h-4" /> VIEW OTHER RIGS
            </button>
          </Link>
        </div>
      </motion.div>
    </section>
  );
}